import apiClient from './api-client';

export interface LTVAdjustment {
  ltv_min: number;
  ltv_max: number;
  adjustment_factor: number;
  description?: string;
}

export interface SASBPremium {
  loan_size_threshold: number;
  premium_rate: number;
  description?: string;
}

export interface LTVAdjustmentCreate {
  ltv_min: number;
  ltv_max: number;
  adjustment_factor: number;
  description?: string;
}

export interface SASBPremiumCreate {
  loan_size_threshold: number;
  premium_rate: number;
  description?: string;
}

export const rpxAdjustmentsService = {
  // LTV Adjustments
  /**
   * Get all LTV adjustment factors
   */
  async getLTVAdjustments(): Promise<LTVAdjustment[]> {
    const response = await apiClient.get('/api/v1/rpx-adjustments/ltv-factor');
    return response.data;
  },

  /**
   * Create or update LTV adjustments in bulk
   */
  async updateLTVAdjustments(
    adjustments: LTVAdjustmentCreate[]
  ): Promise<void> {
    await apiClient.post(
      '/api/v1/rpx-adjustments/ltv-factor/bulk',
      adjustments
    );
  },

  /**
   * Delete all LTV adjustments and replace with new ones
   */
  async replaceLTVAdjustments(
    adjustments: LTVAdjustmentCreate[]
  ): Promise<void> {
    await apiClient.put('/api/v1/rpx-adjustments/ltv-factor/bulk', adjustments);
  },

  // SASB Premiums
  /**
   * Get all SASB premiums
   */
  async getSASBPremiums(): Promise<SASBPremium[]> {
    const response = await apiClient.get(
      '/api/v1/rpx-adjustments/sasb-premium'
    );
    return response.data;
  },

  /**
   * Create or update SASB premiums in bulk
   */
  async updateSASBPremiums(premiums: SASBPremiumCreate[]): Promise<void> {
    await apiClient.post('/api/v1/rpx-adjustments/sasb-premium/bulk', premiums);
  },

  /**
   * Delete all SASB premiums and replace with new ones
   */
  async replaceSASBPremiums(premiums: SASBPremiumCreate[]): Promise<void> {
    await apiClient.put('/api/v1/rpx-adjustments/sasb-premium/bulk', premiums);
  },

  /**
   * Get RPX adjustments summary
   */
  async getAdjustmentsSummary(): Promise<{
    ltv_adjustments_count: number;
    sasb_premiums_count: number;
    last_updated: string;
  }> {
    const response = await apiClient.get('/api/v1/rpx-adjustments/summary');
    return response.data;
  },
};
